var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLixovermelho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.64982 0.379395V0.83724H0.360596V1.75293H0.818441V7.70492C0.818441 7.94778 0.914916 8.18069 1.08664 8.35242C1.25837 8.52414 1.49128 8.62062 1.73413 8.62062H6.31259C6.55544 8.62062 6.78835 8.52414 6.96008 8.35242C7.1318 8.18069 7.22828 7.94778 7.22828 7.70492V1.75293H7.68612V0.83724H5.3969V0.379395H2.64982ZM1.73413 1.75293H6.31259V7.70492H1.73413V1.75293ZM2.64982 2.66862V6.78923H3.56551V2.66862H2.64982ZM4.48121 2.66862V6.78923H5.3969V2.66862H4.48121Z",
    fill: "#B73D3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLixovermelho);
export default __webpack_public_path__ + "static/media/lixovermelho.e9589114de9f67c68bcbce0fc8cbb70b.svg";
export { ForwardRef as ReactComponent };